// fonts
export const FONT_FAMILY = 'sans-serif';
export const FONT_FAMILY_LANDPAGE = 'Raleway, sans-serif';
export const FONT_FAMILY_Cinzel = 'Cinzel, serif';
export const FONT_FAMILY_TEMPLATE = 'Sacramento, cursive';

// colors
export const WHITE_COLOR = '#FFFFFF';
export const TRANSPARENT_COLOR = 'transparent';

// brand colors
export const APP_BACKGROUND_COLOR = '#F5F8FA';
export const PRIMARY_COLOR = '#FC6E51';
export const APP_BRAND_YELLOW_COLOR = '#FFEB3B';

// Mail Room
export const DEFAULT_FONT = 'Montserrat';

export const BLACK_COLOR = '#000000';
export const RANDOM_COLORS = [
  '#ccccff',
  '#ccfff5',
  '#ccffcc',
  '#eeccff',
  '#ffccee',
  '#eeffcc',
  '#ffcccc',
  '#ebebe0',
];
export const DARK_RED = '#ff3333';
export const LIGHT_RED = '#ffcccc';
export const DARK_GREEN = '#5cd65c';
export const LIGHT_GREEN = '#d6f5d6';
export const DARK_BLUE = '#33adff';
export const LIGHT_BLUE = '#ccebff';
export const BASIC_COLOR = '#d2ea8c';
export const SECONDARY_COLOR = '#96d57d';
export const DARK_COLOR = '#007480';
export const LIGHT_COLOR = '#b1e09f';
export const TABLE_HEADER = '#50be77';

//Signup page
export const BTN_SUBMIT = '#FFDE59';

// Go-Create theme config
export const GC_PRIMARY_COLOR = '#042c57';
export const GC_SECONDARY_COLOR = '#d1005b';
export const GC_FONT_FAMILY = 'Montserrat';
export const GC_DOCUMENT_OPTION_BACKGROUND_COLOR = '#042b56';
export const GC_EMAIL_OPTION_BACKGROUND_COLOR = '#d10059';
export const GC_SHORT_MESSAGE_OPTION_BACKGROUND_COLOR = '#6ab4b4';